import moment from 'moment';

export default class PaymentUtils {
  static BASIC_PLAN = { name: 'basic', price: 15 };
  static STANDARD_PLAN = { name: 'standard', price: 40 };
  static DELUXE_PLAN = { name: 'deluxe', price: 100 };
  static BASIC_PACKAGE = { name: 'basic', price: 95 };
  static STANDARD_PACKAGE = { name: 'standard', price: 120 };
  static DELUXE_PACKAGE = { name: 'deluxe', price: 150 };
  static VIDEO_REQUEST_PACKAGE = { name: 'video-request', price: 95 };
  static PACKAGE_STANDARD_VIDEO_REPORT_PLAN = { name: 'Standard', price: process.env.REACT_APP_STANDARD_VIDEO_REPORT_PRICE };
  static PACKAGE_EXPRESS_VIDEO_REPORT_PLAN = { name: 'Express', price: process.env.REACT_APP_EXPRESS_VIDEO_REPORT_PRICE };
  static PACKAGE_FREE_ACCOUNT_PLAN = { name: 'Free', price: '0' };
  static VIDEO_REQUEST_PRICE = 95;
  static STORAGE_MAP = {
    basic: 3,
    standard: 10,
  };

  static DISCOUNT_TYPE = {
    'half-price': 0.5,
  };

  static calculateDiscountType = {
    'half-price': (price) => price * this.DISCOUNT_TYPE['half-price'],
  };

  static VIDEO_BASIC_PACKAGE = {
    description: 'After 12 months, the storage of imaging studies will be renewed for $15 annually. Cancel at any time.',
    featureList: [
      { id: 'video_basic_package_1', text: '1 x Personalized Video Report' },
      { id: 'video_basic_package_2', text: '3 x Radiology Study Storage' },
      { id: 'video_basic_package_3', text: 'Shareable Video Reports' },
      { id: 'video_basic_package_5', text: '30 Day Money Back Guarantee' },
    ],
    name: 'Basic Package',
    plan: this.BASIC_PACKAGE,
    priceDetail: 'One Time',
  };

  static VIDEO_STANDARD_PACKAGE = {
    description: 'After 12 months, the storage of imaging studies will be renewed for $40 annually. Cancel at any time.',
    featureList: [
      { id: 'video_standard_package_1', text: '1 x Personalized Video Report' },
      { id: 'video_standard_package_2', text: '10 x Radiology Study Storage' },
      { id: 'video_standard_package_3', text: 'Shareable Video Reports' },
      { id: 'video_standard_package_5', text: '30 Day Money Back Guarantee' },
    ],
    name: 'Standard Package',
    plan: this.STANDARD_PACKAGE,
    priceDetail: 'One Time',
  };

  static VIDEO_DELUXE_PACKAGE = {
    description: 'After 12 months, the storage of imaging studies will be renewed for $100 annually. Cancel at any time.',
    featureList: [
      { id: 'video_deluxe_package_1', text: '1 x Personalized Video Report' },
      { id: 'video_deluxe_package_2', text: 'UNLIMITED Radiology Study Storage' },
      { id: 'video_deluxe_package_3', text: 'Shareable Video Reports' },
      { id: 'video_deluxe_package_5', text: '30 Day Money Back Guarantee' },
    ],
    name: 'Deluxe Package',
    plan: this.DELUXE_PACKAGE,
    priceDetail: 'One Time',
  };

  static VIDEO_ADDITIONAL_REPORT = {
    description: 'Additional video reports can be requested for a one time fee of $95 regardless of your package.',
    name: 'Additional Video Reports',
    price: 95,
    priceDetail: 'Each',
  };

  static STORAGE_BASIC_PACKAGE = {
    description: 'Storage options are billed once per year and can be canceled at any time.',
    featureList: [
      { id: 'storage_basic_package_1', text: '3 x Radiology Study Storage' },
      { id: 'storage_basic_package_3', text: '30 Day Money Back Guarantee' },
    ],
    name: 'Basic Storage',
    plan: this.BASIC_PLAN,
    priceDetail: 'Billed Annually',
  };

  static STORAGE_STANDARD_PACKAGE = {
    description: 'Storage options are billed once per year and can be canceled at any time.',
    featureList: [
      { id: 'storage_standard_package_1', text: '10 x Radiology Study Storage' },
      { id: 'storage_standard_package_3', text: '30 Day Money Back Guarantee' },
    ],
    name: 'Standard Storage',
    plan: this.STANDARD_PLAN,
    priceDetail: 'Billed Annually',
  };

  static STORAGE_DELUXE_PACKAGE = {
    description: 'Storage options are billed once per year and can be canceled at any time.',
    featureList: [
      { id: 'storage_deluxe_package_1', text: 'UNLIMITED Radiology Study Storage' },
      { id: 'storage_deluxe_package_3', text: '30 Day Money Back Guarantee' },
    ],
    name: 'Deluxe Storage',
    plan: this.DELUXE_PLAN,
    priceDetail: 'Billed Annually',
  };

  static VIDEO_REQUEST_PACKAGE_PLAN = {
    description: 'Storages of images is not included, please ensure your package has enough istorage credits remaining.',
    featureList: [
      { id: 'video_report_plan_1', text: '1 x Personalized Video Repor' },
      { id: 'video_report_plan_2', text: 'Shareable Video Reports' },
      { id: 'video_report_plan_4', text: '30 Day Money Back Guarantee' },
    ],
    name: 'Additional Video Report',
    plan: this.VIDEO_REQUEST_PACKAGE,
    priceDetail: 'One Time',
  };

  static PACKAGE_STANDARD_VIDEO_REPORT = {
    description: 'A personalized video report will be completed by our team and will be viewable online by you within 5 days.',
    featureList: [
      { id: 'package_standard_video_report_1', text: '1x Personalized Video Report' },
      { id: 'package_standard_video_report_2', text: 'Completed within 5 days' },
      { id: 'package_standard_video_report_3', text: 'Sharable Video Reports' },
      { id: 'package_standard_video_report_5', text: '30 Days Money Back Guarantee' },
    ],
    name: 'Standard Video Report',
    plan: this.PACKAGE_STANDARD_VIDEO_REPORT_PLAN,
    priceDetail: 'Within 5 days',
  };

  static PACKAGE_EXPRESS_VIDEO_REPORT = {
    description: 'A personalized video report will be completed by our team and will be viewable online by you within 48 hours.',
    featureList: [
      { id: 'package_express_video_report_1', text: '1x Personalized Video Report' },
      { id: 'package_express_video_report_2', text: 'Completed within 48 hours' },
      { id: 'package_express_video_report_3', text: 'Sharable Video Reports' },
      { id: 'package_express_video_report_5', text: '30 Days Money Back Guarantee' },
    ],
    name: 'Express Video Report',
    plan: this.PACKAGE_EXPRESS_VIDEO_REPORT_PLAN,
    priceDetail: 'Within 48 Hours',
  };

  static PACKAGE_FREE_ACCOUNT = {
    description: 'Help yourself learn more about your results or sample how our service can help you',
    featureList: [
      { id: 'package_free_account_1', text: 'Sample video report and MRI scan' },
      { id: 'package_free_account_2', text: 'Store and view your MRI/CT scans.' },
      { id: 'package_free_account_3', text: 'Self-help articles & videos.' },
      { id: 'package_free_account_4', text: 'Access anywhere on any device.' },
    ],
    name: 'Free Account',
    plan: this.PACKAGE_FREE_ACCOUNT_PLAN,
    priceDetail: 'Self-Help/Free Trial',
  };

  static calculateStandardUpgrade(expiredAt) {
    return this.calculateUpgrade(expiredAt, this.BASIC_PLAN.price, this.STANDARD_PLAN.price);
  }

  static calculateDeluxeUpgradeFromBasic(expiredAt) {
    return this.calculateUpgrade(expiredAt, this.BASIC_PLAN.price, this.DELUXE_PLAN.price);
  }

  static calculateDeluxeUpgradeFromStandard(expiredAt) {
    return this.calculateUpgrade(expiredAt, this.STANDARD_PLAN.price, this.DELUXE_PLAN.price);
  }

  static calculateUpgrade(expiredAt, currentPrice, nextPrice) {
    if (!expiredAt) {
      return nextPrice;
    }

    const now = moment();
    const expiredAtMoment = moment(expiredAt);

    if (now.isAfter(expiredAtMoment)) {
      return nextPrice;
    }

    const days = Math.ceil(moment.duration(expiredAtMoment.diff(now)).asDays());
    const used = Math.ceil((currentPrice * (365 - days)) / 365);
    const unused = currentPrice - used;
    const newPlan = Math.min(Math.ceil((nextPrice * days) / 365), nextPrice);
    return Math.max(newPlan - unused, 0);
  }

  static getAvailablePlans(oldPlan) {
    switch (oldPlan) {
      case 'basic':
        return ['basic', 'standard', 'deluxe'];
      case 'standard':
        return ['standard', 'deluxe'];
      case 'deluxe':
        return ['deluxe'];
      default:
        break;
    }
    return [];
  }

  static getShouldDowngrade(studyCount, newPlan) {
    return newPlan === 'deluxe' || this.STORAGE_MAP[newPlan] >= studyCount;
  }
}
